const domElements = {
    body: document.body,
    header: document.querySelector('.header'),
}

export const toggleDarkModeBody = () => {
    domElements.header?.classList.toggle('dark-background');
    domElements.body.classList.toggle('no-scroll');
}

export const isDarkModeActive = () => {
    return domElements.header.classList.contains('dark-background');
}

export const toggleDarModeStatement = (statement) => {
    if(!statement) {
        return false;
    }

    toggleDarkModeBody();
}

export const disableDarkModeIfNotClosest = (e, closest) => {
    const {target} = e;

    if(!domElements.header.classList.contains('dark-background')) {
        return false
    }

    if (!target.matches(closest) || !target.closest(closest)) {
        return false;
    }

    toggleDarkModeBody();

    return true;
}

export const toggleToastsVisibility = (id) => {
    const toast = document.getElementById(id);
    toast?.classList?.toggle('show');
}


const addPaddingIfBottomBannerExists = () => {
    const bottomBanner = document.querySelector('.fixed-bottom-banner');
    if(!bottomBanner) return;

    const bannerHeight = bottomBanner.getBoundingClientRect().height;
    domElements.body.style.paddingBottom = `${bannerHeight}px`;
}

addPaddingIfBottomBannerExists();
window.addEventListener('resize', addPaddingIfBottomBannerExists);
